import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat.js';
dayjs.extend(customParseFormat);
var formatHourMinuteToString = function formatHourMinuteToString(hourMinute) {
    var time = dayjs("".concat(hourMinute.hour, ":").concat(hourMinute.minute), 'H:m');
    return time.format('HH:mm');
};
var formatStringToHourMinute = function formatStringToHourMinute(value) {
    var time = dayjs(value, 'hh:mm');
    return {
        hour: Number(time.format('H')),
        minute: Number(time.format('m'))
    };
};
export var TimePickerUtils = {
    formatHourMinuteToString: formatHourMinuteToString,
    formatStringToHourMinute: formatStringToHourMinute
};

//# sourceMappingURL=TimePickerInputUtils.js.map